module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Hb-Ib.1f04d8e0.png";